import { useContext } from 'react';
import * as R from 'ramda';

import MoveElementModalContext, {
  ModalStep,
} from '@atom/components/common/moveElement/MoveElementModalContext';
import { Stepper } from '@atom/mui';

import classes from './moveElement.module.css';

const { StepLabel, Step } = Stepper;

const StepperSidebar = () => {
  const {
    activeStep,
    STEPS_ARRAY,
    element,
    destinationAsset,
    destinationAssetPath,
  } = useContext(MoveElementModalContext);

  const activeStepIndex = R.findIndex(R.propEq(activeStep, 'value'))(
    STEPS_ARRAY,
  );

  const getStepDisplay = (step: ModalStep): { title: any; subtext: any } => {
    const rootAssetName = R.head(element?.ancestors || [])?.name;
    const destinationPathDisplay = destinationAssetPath
      .map(item => item.name)
      .join(' / ');

    switch (step) {
      case ModalStep.ELEMENT: {
        return {
          title: `Move: ${element?.name}`,
          subtext: `From: ${rootAssetName}`,
        };
      }
      case ModalStep.DESTINATION: {
        return {
          title: 'Select Destination',
          subtext: R.isNil(destinationAsset)
            ? ''
            : `To: ${destinationPathDisplay}`,
        };
      }
      case ModalStep.CONFIRM: {
        return { title: 'Confirm', subtext: '' };
      }
      default: {
        return { title: '', subtext: '' };
      }
    }
  };

  return (
    <div className={classes.stepperContainer}>
      <Stepper activeStep={activeStepIndex} orientation="vertical">
        {STEPS_ARRAY.map(step => {
          const display = getStepDisplay(step.value);

          return (
            <Step key={display.title}>
              <StepLabel error={false}>
                <>
                  <div>{display.title}</div>
                  {display.subtext && (
                    <div className={classes.stepSubtext}>{display.subtext}</div>
                  )}
                </>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};

export default StepperSidebar;
